export default function PlayerRequirements() {
  return (
    <div className="prose">
      <h2>Requirements</h2>
      <p>Minimum and recommended requirements for running the Q-Play player software.</p>
      <ul>
        <li>CPU, RAM, storage — Todo</li>
        <li>Network and ports — Todo</li>
        <li>Graphics acceleration — Todo</li>
      </ul>
    </div>
  )
}
